import {alpha, Box, IconButton, Toolbar, Tooltip, Typography} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {Link, useSearchParams} from "react-router-dom";
import UserDetailForm from "./UserDetailForm";
import {useTranslation} from "react-i18next";

export default function UserCreate() {
    const {t} = useTranslation();
    const [searchParams] = useSearchParams();

    return (
        <Box>
            <Toolbar
                sx={{
                    pl: {sm: 2},
                    pr: {xs: 1, sm: 1},
                    ...{
                        bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                    },
                }}
            >
                <Tooltip title="Back to list">
                    <IconButton component={Link} to={`/users?${searchParams}`}>
                        <ArrowBackIcon />
                    </IconButton>
                </Tooltip>
                <Typography variant="h6" id="tableTitle" component="div">
                    {t("action_createUser")}
                </Typography>
            </Toolbar>
            <UserDetailForm />
        </Box>
    );
}
